<template>
    <div class="unbind">
        <div class='con' v-if='active==1'><!--扫码-->
            <img src="@/assets/img/mine/nobind.png" class="imgs">
            <p class="gray">暂无绑定设备</p>
            
            <div class="btn-primary bindBtn" @click="getWx">扫码绑定设备</div>
            <p class="gray">多次扫码不成功，试试<span class='blue' @click="gotoUrl('inputbind',{bindType:bindType},1)">输入IMEI序列号</span></p>
        </div>
        
        <p class="logoutBtn" v-if="bindType==1" @click="gotoUrl('routePage', {pageType: 'DO_LOGOUT'})">退出登录</p>   
       <!-- <div class='loading' v-if="loading"><van-loading type="spinner" color="#fff" /></div> -->
    </div>
</template>
<script>
   import {binding,verifyAvailabilityByImei} from '@/api/api.mine.js';
   import wxapi from '@/utils/wxapi.js';
    export default {
        data() {
            return {
                active:1,
                imei:'',
                bindType:this.$route.query.bindType,//默认子女去绑定 1 家长登录无子女 2 添加子女 
            }
        },
        created(){
                var url=location.href.split('#')[0];
                var appid=ENV_API.APP_ID;
                wxapi.wxRegister(appid,url);
        },
        methods:{
            getWx(){
                let option={
                        success:(data)=>{
                            this.imei=data;
                            this.handleClick();
                        }
                    }
                wxapi.wxScan(option);
            },
            
            handleClick(){
                // if(checkPwd(this.phone)){
                    if(this.imei == ""){
                        this.$toast('请输入设备IMEI序列号')
                    }else{
                        if(this.bindType){//无子女
                           verifyAvailabilityByImei({imei:this.imei,}).then(data=>{
                               if(data.result){
                                   this.gotoUrl('bindChildren',{imei:this.imei});
                               }
                           })
                        }else{
                             binding({
                                phone:this.phone,
                                imei:this.imei,
                                studentId:this.loginUser.studentId
                             }).then(data=>{
                                // this.loading=false;
                                if(data.code=='00000'){
                                    this.$toast('绑定成功');
                                    this.$router.replace({name:'bind'});
                                }
                             })
                        }
                       
                    }

             
            },
        }
    }
</script>
<style lang="scss" >
    .unbind{
        height:100%;
        font-size: .18rem;
        .imgs{
            width: 1.2rem;
            height: 1.2rem;
        }
       .logoutBtn{
           position:fixed;
           bottom: .48rem;
           width: 100%;
           text-align: center;
           font-size:.16rem;
           color:#0A59F7;
       }
        .con{
            position: relative;
            text-align: center;
            padding:.6rem .3rem 0;
            color: #333;
            .bindBtn{
                margin-top: .6rem;
                margin-bottom: .2rem;
            }
            .blue{
                    color:#0A59F7; 
                }
           
        }
   
    }
</style>
